import { format, formatDuration as _formatDuration, Duration } from 'date-fns';
import * as locales from 'date-fns/locale';
import { getCulture } from 'utils/culture';

// const matchLocale = (locale: string) => {
//   const locales = {
//     ua: 'uk',
//     en: 'en-US',
//     zh: 'zh-TW',
//   };

//   // @ts-ignore TODO LATER FIX IMPLICIT ANY
//   return locales[locale] || locale;
// };

export const getLocale = (locale: string) => {
  try {
    return locales[locale] || locales.enUS;
    // return require(`date-fns/locale/${matchLocale(locale)}/index.js`);
    // return await import(/* @vite-ignore */ `date-fns/locale/${matchLocale(locale)}/index.js`);
  } catch (error) {
    console.warn(error);
    return locales.enUS;
    // return require('date-fns/locale/en-US/index.js');
  }
};

export const formatDate = (date?: Date | string | null, pattern = 'dd-MM-yyyy') => {
  if (!date) return '';
  const culture = getCulture();

  const locale = getLocale(culture);

  if (date instanceof Date) {
    return format(date, pattern, { locale });
  }
  return format(new Date(date), pattern, { locale });
};

export const formatDuration = (duration: Duration, _format?: Array<keyof Duration>) => {
  const culture = getCulture();

  const locale = getLocale(culture);

  return _formatDuration(duration, { format: _format, locale });
};

// export const useFormatDate = (date?: Date | string | null, pattern = 'dd-MM-yyyy') => {
//   const [formatted, updateFormatted] = useState<string>();

//   useEffect(() => {
//     formatDate(date, pattern).then(updateFormatted);
//   }, []);

//   return formatted;
// };
